import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ITreeCodeReq } from '../../../models/treeCodes.model'
import { doCreateCode, doGetCodes } from '../../../store/treeCode.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';
import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/treeCode/Editor';
import { errorVariant, infoVariant, successVariant, warningVariant } from '../../../lib/barVariant';

const SystemTreeCodeCreate: FC<RouteComponentProps> = ({
  history,
  location,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.code);
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async (req: ITreeCodeReq) => {
    const res = await dispatch(doCreateCode(req));

    switch (res?.status) {
      case 200:
        dispatch(doGetCodes());
        enqueueSnackbar(t('common.message.create'), successVariant);
        history.push(`/system/treecode${location.search}`);
        break;
      case 400:
        enqueueSnackbar(t('system.code.message1'), infoVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.code.title2')}
      />
      <Editor
        code={null}
        onSubmit={onSubmit}
        cancelPath={null}
      />
      <Footer />
    </div>
  )
}

export default SystemTreeCodeCreate;
